import axios, {AxiosResponse} from "axios";
import {PagedResult} from "@/service/PagedResult";

const PATH = "/v2/orders";
const PATH_V3 = "/v3/orders";

export interface OrderOperatorCreateRequest {
  employeeId: number;
  operatorNumber?: number;
  numberOfPositions?: number;
  qualityLevel?: string;
  valueOfGoods?: number;
}

export interface OrderOperatorUpdateRequestV3 {
  operatorNumber?: number;
  numberOfPositions?: number;
  qualityLevel?: string;
  valueOfGoods?: number;
}

export interface OrderOperatorCreateRequestV3 extends OrderOperatorUpdateRequestV3 {
  employeeId: string;
}

export interface OrderOperatorV3Dto {
  id: string;
  operatorNumber?: number;
  employee: {
    id: string;
    employeeNumber?: number;
    firstName: string;
    lastName: string;
  };
  numberOfPositions?: number;
  qualityLevel?: string;
  valueOfGoods?: number;
}

class OrderOperatorService {

  getOrderOperators (orderId: number): Promise<AxiosResponse<PagedResult>> {
    return axios.get(`${PATH}/${orderId}/operators`);
  }

  createOrderOperator (orderId: number, data: OrderOperatorCreateRequest) {
    return axios.post(`${PATH}/${orderId}/operators`, data, { headers: { "Content-Type": "application/json" } });
  }

  getOrderWorklogs (orderId: number): Promise<AxiosResponse<PagedResult>> {
    return axios.get(`${PATH}/${orderId}/operators/worklogs`);
  }

  getOrderOperatorsV3 (orderUuid: string): Promise<AxiosResponse<{ operators: Array<OrderOperatorV3Dto> }>> {
    return axios.get(`${PATH_V3}/${orderUuid}/operators`);
  }

  createOrderOperatorV3 (orderUuid: string, data: OrderOperatorCreateRequestV3): Promise<AxiosResponse<OrderOperatorV3Dto>> {
    return axios.post(`${PATH_V3}/${orderUuid}/operators`, data, { headers: { "Content-Type": "application/json" } });
  }

  updateOrderOperatorV3 (orderUuid: string, operatorId: string, data: OrderOperatorUpdateRequestV3): Promise<AxiosResponse<OrderOperatorV3Dto>> {
    return axios.put(`${PATH_V3}/${orderUuid}/operators/${operatorId}`, data, { headers: { "Content-Type": "application/json" } });
  }
}

export default new OrderOperatorService();
